module.exports = __webpack_public_path__ + "static/media/pdLogo.3f3d7ad6.svg";